export default "__VITE_ASSET__tFnSymyg__"